import { environment } from '../../environments/environment';

export class Constants {
	public static readonly BASE_API_URL = environment.restapi_url;
	public static readonly BASE_URL = environment.mainsite_url;
	public static readonly BASE_ASSET_URL = environment.mainsite_url;
	public static readonly FACEBOOK_APP_ID = environment.facebookAppId;
	public static readonly GOOGLE_CLIENT_ID = environment.googleClientId;
	public static readonly GOOGLE_API_KEY = environment.googleAPIkey;

	public static readonly HOME_URL = '/home';
	public static readonly MAINTENANCE_LOGIN_URL = ['/login', '/under-maintenance'];
	public static readonly LOGIN_URL = Constants.MAINTENANCE_LOGIN_URL[0];
}
